module.exports = __webpack_public_path__ + "assets1775130923925/img/avator.bd584bb1.png";